'use strict';

import { authenticate } from "passport";

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('messages', {
      url: '/account/messages',
      template: '<messages></messages>',
      authenticate: true
    })
    .state('message-detail', {  
      url: '/account/message',     // Changed URL pattern to be relative
      template: '<message-detail></message-detail>',
      params: {
        messageData: null,
        submissionId: null,
        message_chain_id: null,
        data: null
      },
      component: 'messageDetail',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/messages/messages.routes.js